import { useTranslation } from 'react-i18next';
import TripType from './TripType';
import { SearchFields } from './SearchFields';
import { FormType, initialState, TripTypes } from '../../shared/models/form';
import { useForm, FormProvider } from 'react-hook-form';
import { submitHandler } from './submitHandler';
import Currency from './Currency';
import LowestFare from './LowestFare';
import useResizeObserver from './useResizeObserver';

const App = () => {
  const ref = useResizeObserver<HTMLFormElement>();
  const { t } = useTranslation();
  const formHookData = useForm({ defaultValues: initialState, mode: 'onBlur' });
  const { handleSubmit } = formHookData;

  return (
    <FormProvider<FormType> {...formHookData}>
      <form onSubmit={handleSubmit(submitHandler)} className="p-2 md:p-4" ref={ref}>
        <div className="flex flex-col md:flex-row w-full md:justify-between gap-y-8">
          <div className="inline-flex gap-x-8 items-end pl-2">
            <TripType label={t('Round Trip')} value={TripTypes.roundTrip} />
            <TripType label={t('One Way')} value={TripTypes.oneWay} />
            <TripType label={t('Multi-city')} value={TripTypes.multiCity} />
          </div>
          <Currency />
        </div>
        <SearchFields />
        <div className="flex flex-col gap-4 mt-8 md:flex-row md:gap-0">
          <LowestFare />
          <button
            className="px-8 py-2.5 rounded h-[50px] text-sm text-black font-semibold bg-gradient-to-b from-[rgb(187,212,70)] to-[rgb(151,171,56)] border-[rgb(187,212,70)] border focus:ring-gray-500 focus:ring-2 focus:ring-offset-0 focus:outline-none"
            type="submit"
          >
            {t('Search')}
          </button>
        </div>
      </form>
    </FormProvider>
  );
};

export default App;
